/**
 * Cleans text from PII by replacing student name and grade in text with <Student Header> stub.
 * Student name and grade should follow the header format of `FirstName LastName - Grade X`.
 */

import keycloak from '../keycloak/keycloak';

const concealStudentData = text => {
    const stubbedText = '<Student Header>';
    return text.replace(/([\w -]+?)-?Grade ([\w-]*)/, stubbedText).replace(keycloak.tokenParsed.name, stubbedText);
};

export default concealStudentData;
